import instance from 'utils/axios/instance.axios';
import { FINANCIAL_REVIEW } from './_constant';

export const getInfo = (councilId, projectProposalId, userId) =>
  instance.get(FINANCIAL_REVIEW.GET_INFO, {
    params: { councilId, projectProposalId, userId },
  });

export const getDetail = (councilMemberId, councilId, projectProposalId) =>
  instance.get(FINANCIAL_REVIEW.GET_DETAIL, {
    params: { councilMemberId, councilId, projectProposalId },
  });

export const create = (data = {}) => instance.post(FINANCIAL_REVIEW.CREATE, data);

export const update = ({ data, id }) => instance.patch(FINANCIAL_REVIEW.UPDATE(id), data);

export const submit = (data = {}) => instance.post(FINANCIAL_REVIEW.SUBMIT, data);

// Review file

export const getDetailFile = (councilMemberId, councilId, projectProposalId) =>
  instance.get(FINANCIAL_REVIEW.GET_DETAIL_FILE, {
    params: { councilMemberId, councilId, projectProposalId },
  });

export const uploadDetailFile = (body = {}) =>
  instance.post(FINANCIAL_REVIEW.UPLOAD_DETAIL_FILE, body);

export const updateDetailFile = (body = {}) =>
  instance.patch(FINANCIAL_REVIEW.UPDATE_DETAIL_FILE, body);

export const downloadDetailFile = (body = {}) =>
  instance.post(FINANCIAL_REVIEW.DOWNLOAD_DETAIL_FILE, body, { responseType: 'blob' });

export const submitDetailFile = (body = {}) =>
  instance.patch(FINANCIAL_REVIEW.SUBMIT_DETAIL_FILE, body);

export const downloadPdfFile = ({ projectProposalId, councilId, councilMemberId }) =>
  instance.post(
    FINANCIAL_REVIEW.DOWNLOAD_PDF_FILE,
    {
      projectProposalId,
      councilId,
      councilMemberId,
    },
    {
      responseType: 'blob',
    }
  );

export const downloadPdfTemplate = ({ projectProposalId, councilId, councilMemberId }) =>
  instance.post(
    FINANCIAL_REVIEW.DOWNLOAD_PDF_TEMPLATE,
    {
      projectProposalId,
      councilId,
      councilMemberId,
    },
    {
      responseType: 'blob',
    }
  );

export const downloadDocxFile = ({ projectProposalId, councilId, councilMemberId }) =>
  instance.post(
    FINANCIAL_REVIEW.DOWNLOAD_DOCX_FILE,
    {
      projectProposalId,
      councilId,
      councilMemberId,
    },
    {
      responseType: 'blob',
    }
  );
export const downloadDocxTemplate = ({ projectProposalId, councilId, councilMemberId }) =>
  instance.post(
    FINANCIAL_REVIEW.DOWNLOAD_DOCX_TEMPLATE,
    {
      projectProposalId,
      councilId,
      councilMemberId,
    },
    {
      responseType: 'blob',
    }
  );
